export class Descriptor {
	public id: string;
	public value: string;
	public additionalAttrs: Array<any> = [];
}
